angular.module("app").constant("appTypes", [
    "sportsbook",
    "casino"
]);